// extracted by mini-css-extract-plugin
module.exports = {"link":"messageMenu_link__DTbOJ page_myLink__1r3Bh","text":"messageMenu_text__d7Tt7","messageMenu":"messageMenu_messageMenu__WGVY0"};